document.addEventListener("DOMContentLoaded", async function () {
  const selectVariant = document.querySelector(".nrx_variant-picker .product-form__input:first-child");
  const productVariantId = document.querySelector("input[type='hidden'].product-variant-id");
  const variantPicker = document.querySelector(".nrx_variant-picker");
  const shopURL = window.urlColors;
  const documentStyle = document.documentElement.style;
  let colorMap = null;

  try {
    const colors = await getColors();
    colorMap = buildColorMap(colors);
    updateColorSwatch();

    productVariantId.addEventListener("change", updateColorSwatch);
  } catch (e) {

  }

  async function getColors() {
    // const response = await fetch(`${shopURL}/t/13/assets/colors.json?v=${Date.now()}`);
    const response = await fetch(shopURL);
    // if (!response.ok) throw new Error("Impossibile caricare colors.json");
    return await response.json();
  }

  function buildColorMap(colors) {
    const map = new Map();
    for (const el of colors) {
      map.set(el.nome_colore.trim().toLowerCase(), {
        asset_colore: el.asset_colore,
        colore_hex: el.colore_hex
      });
    }
    return map;
  }

  function pickColor(color) {
    if (!colorMap) return {};
    //console.log(colorMap);
    return colorMap.get(color.trim().toLowerCase()) || {};
  }

  function updateColorSwatch() {
    variantPicker.setAttribute("isLoading", "true");
    const variantDataEl = document.querySelector("[data-selected-variant]");
    if (!variantDataEl) return;
    let updatedVariantData;
    try {
      updatedVariantData = JSON.parse(variantDataEl.textContent);
    } catch {
      variantPicker.setAttribute("isLoading", "false");
      return;
    }
    const colorAsset = pickColor(updatedVariantData.option1);
    console.log(colorAsset);
    let { asset_colore, colore_hex } = colorAsset;
    // console.log(colorAsset);
    // console.log(updatedVariantData.option1);
    if (asset_colore) {
      documentStyle.setProperty('--cw-img', `url('https://www.ripadesign.com/cdn/shop/files/${asset_colore}')`);
      documentStyle.setProperty('--cw-color', 'none');
    } else if (colore_hex) {
      documentStyle.setProperty('--cw-img', 'none');
      documentStyle.setProperty('--cw-color', colore_hex);
    } else {
      documentStyle.setProperty('--cw-img', 'none');
      documentStyle.setProperty('--cw-color', 'transparent');
    }
    variantPicker.setAttribute("isLoading", "false");
  }
});